'use client';

export * from 'tailframes-components/components/textarea';
